import Address from "./Flow_CompanyDetails/steps/Address"
import Organization from "./Flow_CompanyDetails/steps/Organization"
import IndustryEligibility from "./Flow_CompanyDetails/steps/IndustryEligibility"
import Contact from "./Flow_CompanyDetails/steps/Contact"
import { Plans, Plan, Dates, ExcludedGroups, Groups, EligibleExpenses, Allowance, AllowanceMetal, AllowanceACA, TextToConfirm, ReimbursementMethod, ReimbursementTiming,Classes, EligibleIndividuals, AllowanceType } from "./Flow_Plans/steps"
import ReimbursementAccount from "./Flow_Reimbursements/steps/ReimbursementAccount"
import Billing from "./Flow_Billing/steps/Billing"
import Documents from "./Flow_Documents/steps/Documents"

export function getNavigationMenu(section, step, onboarding, employer, employerPlan = null, permissibleClass = null) {
    // console.log(`In employerFlow getNavigationMenu, section = ${section}, step = ${step}, onboarding = ${onboarding}, employer = ${employer?.id}, employerPlan = ${employerPlan?.id}, permissibleClass = ${permissibleClass?.id}, employer.reimbursements = ${employer?.signupStatus?.reimbursements?.required} and billing = ${employer?.signupStatus?.billing?.required}`);
    const planType = employerPlan?.type;
    // console.log(`In employerFlow getNavigationMenu, employerPlan = `, employerPlan);
    // console.log(`In employerFlow getNavigationMenu, permissibleClass = `, permissibleClass);
    const signupStatus = employer?.signupStatus || {};
    const menuItems = [];

    if (section === "company_details" || (signupStatus?.companyInfo?.required && onboarding)) {
        let organizationCompleted = false;
        if (employer?.organizationType && employer?.ein?.length === 9 && employer?.registrationState?.length === 2) {
            organizationCompleted = true;
        }
        const companyUrl = `/employer-flow/company-details?onboarding=${onboarding}&step=0`;
        const company = {
            label: "Company",
            section: "company_details",
            disabled: !employer?.signupStatus?.companyInfo?.editable || false,
            url: companyUrl,
            //handleNext: plans?.onClick,
        }
        if (section === "company_details") {
            const url1 = `/employer-flow/company-details?onboarding=${onboarding}&step=0`;
            const url2 = `/employer-flow/company-details?onboarding=${onboarding}&step=1`;
            const url3 = `/employer-flow/company-details?onboarding=${onboarding}&step=2`;
            company.steps = [
                {
                    label: "Address",
                    name: "Address",
                    disabled: false,
                    url: url1,
                    // onClick: () => setSearchParams("step", steps?.address?.value)
                },
                {
                    label: "Organization",
                    name: "Organization",
                    disabled: step < 1 && signupStatus?.companyInfo?.complete !== true && !organizationCompleted,
                    url: url2,
                    // onClick: () => setSearchParams("step", steps?.organization?.value)
                },
                {
                    label: "Contact",
                    name: "Contact",
                    disabled: step < 2 && signupStatus?.companyInfo?.complete !== true,
                    url: url3,
                    // onClick: () => setSearchParams("step", steps?.contact?.value)
                },
            ]
        }
        menuItems.push(company);
    }
    if (section === "plans" || (signupStatus?.plans?.required && onboarding)) {
        const urlPlans = `/employer-flow/plans?onboarding=${onboarding}&step=0`;
        const plans = {
            label: "Plan Settings",
            section: "plans",
            disabled: !signupStatus?.plans?.editable || false,
            url: urlPlans,
        }
        if (section === "plans") {
            const menuSteps = [];
            let numMenuStep = 0;
            let menuStep = {
                label: "Plan Type",
                name: "Plans",
                disabled: false,
                url: urlPlans,
            }
            menuSteps.push(menuStep);
            numMenuStep++;
            if (employerPlan) {
                let hasPlanYear = false;
                if (employerPlan?.midYearPlan !== null && employerPlan?.endDate?.length === 10) {
                    hasPlanYear = true;
                }
                let hasClasses = false;
                if (hasPlanYear && employerPlan?.permissibleClasses?.length > 0) {
                    hasClasses = true;
                }
                let hasGroups = false;
                if (hasClasses && permissibleClass?.predefinedClasses?.length > 0) {
                    hasGroups = true;
                }
                let hasEligibleExpenses = false;
                if (hasGroups && permissibleClass?.qualifiedBenefits?.length > 0) {
                    if (permissibleClass.qualifiedBenefits[0]?.type !== "NONE") {
                        hasEligibleExpenses = true;
                    }
                }
                let hasAllowanceType = false;
                if (hasEligibleExpenses) {
                    const allowanceMethod = permissibleClass?.allowanceMethod;
                    // Tolerates both shapes: a string/array (.length) and the
                    // object form the form writes, e.g. { MANUAL: true }.
                    if (typeof allowanceMethod === "object" && allowanceMethod !== null) {
                        hasAllowanceType = Object.values(allowanceMethod).some(Boolean);
                    } else {
                        hasAllowanceType = allowanceMethod?.length > 0;
                    }
                }
                let hasReimbursementMethod = false;
                if (hasClasses && employerPlan?.reimbursementDistributionMethod) {
                    hasReimbursementMethod = true;
                }
                if (planType === "QSEHRA") {
                    const urlStatus = `/employer-flow/plans?onboarding=${onboarding}&step=${numMenuStep}&planId=${employerPlan?.id}`;
                    menuStep = {
                        label: `${planType} Status`,
                        name: "Plan Status",
                        disabled: step < numMenuStep && !employerPlan.isComplete && !hasPlanYear,
                        url: urlStatus,
                    }
                    menuSteps.push(menuStep);
                    numMenuStep++;
                    const urlYear = `/employer-flow/plans?onboarding=${onboarding}&step=${numMenuStep}&planId=${employerPlan?.id}`;
                    menuStep = {
                        label: `Plan Year`,
                        name: "Plan Year",
                        disabled: step < numMenuStep && !employerPlan.isComplete && !hasPlanYear,
                        url: urlYear,
                    }
                    menuSteps.push(menuStep);
                    numMenuStep++;
                    const urlClass = `/employer-flow/plans?onboarding=${onboarding}&step=${numMenuStep}&classId=${permissibleClass?.id}`;
                    menuStep = {
                        label: `Excluded Groups`,
                        name: "Excluded Groups",
                        disabled: step < numMenuStep && !employerPlan.isComplete && !hasPlanYear,
                        url: urlClass,
                    }
                    menuSteps.push(menuStep);
                    numMenuStep++;
                    const urlExpenses = `/employer-flow/plans?onboarding=${onboarding}&step=${numMenuStep}&classId=${permissibleClass?.id}`;
                    menuStep = {
                        label: `Eligible Expenses`,
                        name: "Eligible Expenses",
                        disabled: step < numMenuStep && !employerPlan.isComplete && !hasGroups,
                        url: urlExpenses,
                    }
                    menuSteps.push(menuStep);
                    numMenuStep++;
                    const urlBenefit = `/employer-flow/plans?onboarding=${onboarding}&step=${numMenuStep}&classId=${permissibleClass?.id}`;
                    menuStep = {
                        label: `Monthly Allowance`,
                        name: "Allowance",
                        disabled: step < numMenuStep && !employerPlan.isComplete && !hasEligibleExpenses,
                        url: urlBenefit,
                    }
                    menuSteps.push(menuStep);
                    numMenuStep++;

                } else {
                    const urlStatus = `/employer-flow/plans?onboarding=${onboarding}&step=${numMenuStep}&planId=${employerPlan?.id}`;
                    menuStep = {
                        label: `${planType} Status`,
                        name: "Plan Status",
                        disabled: step < numMenuStep && !employerPlan.isComplete && !hasPlanYear,
                        url: urlStatus,
                    }
                    menuSteps.push(menuStep);
                    numMenuStep++;
                    const urlYear = `/employer-flow/plans?onboarding=${onboarding}&step=${numMenuStep}&planId=${employerPlan?.id}`;
                    menuStep = {
                        label: `Plan Year`,
                        name: "Plan Year",
                        disabled: step < numMenuStep && !employerPlan.isComplete && !hasPlanYear,
                        url: urlYear,
                    }
                    menuSteps.push(menuStep);
                    numMenuStep++;
                    const urlClass = `/employer-flow/plans?onboarding=${onboarding}&step=${numMenuStep}&planId=${employerPlan?.id}`;
                    menuStep = {
                        label: `Employee Classes`,
                        name: "Classes",
                        disabled: step < numMenuStep && !employerPlan.isComplete && !hasPlanYear,
                        url: urlClass,
                    }
                    menuSteps.push(menuStep);
                    numMenuStep++;
                    if (permissibleClass) {
                        const urlGroups = `/employer-flow/plans?onboarding=${onboarding}&step=${numMenuStep}&classId=${permissibleClass?.id}`;
                        menuStep = {
                            label: `Employee Groups`,
                            name: "Employee Groups",
                            disabled: step < numMenuStep && !permissibleClass.isComplete && !hasGroups,
                            url: urlGroups,
                            subMenu: true
                        }
                        menuSteps.push(menuStep);
                        numMenuStep++;
                        const urlExpenses = `/employer-flow/plans?onboarding=${onboarding}&step=${numMenuStep}&classId=${permissibleClass?.id}`;
                        menuStep = {
                            label: `Eligible Expenses`,
                            name: "Eligible Expenses",
                            disabled: step < numMenuStep && !permissibleClass.isComplete && !hasGroups,
                            url: urlExpenses,
                            subMenu: true
                        }
                        menuSteps.push(menuStep);
                        numMenuStep++;
                        if (planType === "ICHRA") {
                            const urlAllowance = `/employer-flow/plans?onboarding=${onboarding}&step=${numMenuStep}&classId=${permissibleClass?.id}`;
                            menuStep = {
                                label: `Monthly Allowance`,
                                name: "Allowance Type",
                                // Gates on the step before it (Eligible Expenses),
                                // matching its two neighbours. Previously gated on
                                // hasEligibleIndividuals, which is set by the step
                                // *after* this one.
                                disabled: step < numMenuStep && !permissibleClass.isComplete && !hasEligibleExpenses,
                                url: urlAllowance,
                                subMenu: true,
                            }
                            menuSteps.push(menuStep);
                            numMenuStep++;

                            const urlCovered = `/employer-flow/plans?onboarding=${onboarding}&step=${numMenuStep}&classId=${permissibleClass?.id}`;
                            menuStep = {
                                label: `Eligible Individuals`,
                                name: "Eligible Individuals",
                                // Allowance must be set first — a family allowance
                                // changes what's offered here.
                                disabled: step < numMenuStep && !permissibleClass.isComplete && !hasAllowanceType,
                                url: urlCovered,
                                returnUrl: urlClass,
                                subMenu: true

                            }
                            menuSteps.push(menuStep);
                            numMenuStep++;
                        }
                    }
                }
                const urlReimbursement = `/employer-flow/plans?onboarding=${onboarding}&step=${numMenuStep}&planId=${employerPlan?.id}`;
                menuStep = {
                    label: `Reimbursement Method`,
                    name: "Reimbursement Method",
                    disabled: (permissibleClass && planType !== "QSEHRA") || (step < numMenuStep && !employerPlan.isComplete && !hasClasses),
                    url: urlReimbursement,
                }
                menuSteps.push(menuStep);
                numMenuStep++;
                const urlReimbursementTiming = `/employer-flow/plans?onboarding=${onboarding}&step=${numMenuStep}&planId=${employerPlan?.id}`;
                menuStep = {
                    label: `Reimbursement Timing`,
                    name: "Reimbursement Timing",
                    disabled: (permissibleClass && planType !== "QSEHRA") || (step < numMenuStep && !employerPlan.isComplete && !hasReimbursementMethod),
                    url: urlReimbursementTiming,
                }
                menuSteps.push(menuStep);
                numMenuStep++;
                const urlTextToConfirm = `/employer-flow/plans?onboarding=${onboarding}&step=${numMenuStep}&planId=${employerPlan?.id}`;
                menuStep = {
                    label: `Text-To-Confirm`,
                    name: "Text-To-Confirm",
                    disabled: (permissibleClass && planType !== "QSEHRA") || (step < numMenuStep && !employerPlan.isComplete && !hasReimbursementMethod),
                    url: urlTextToConfirm,
                }
                menuSteps.push(menuStep);
                numMenuStep++;
            }
            plans.steps = menuSteps;
        }
        menuItems.push(plans);
    }
    if (section === "reimbursements" || (signupStatus?.reimbursements?.required && onboarding)) {
        const urlReimbursements = `/employer-flow/reimbursements?onboarding=${onboarding}&step=0`;
        const reimbursements = {
            label: "Reimbursements",
            section: "reimbursements",
            disabled: !signupStatus?.reimbursements?.editable || false,
            url: urlReimbursements,
        }
        if (section === "reimbursements") {
            reimbursements.steps = [
                {
                    label: "Reimbursement Account",
                    name: "Reimbursement Account",
                    disabled: false,
                    url: urlReimbursements,
                },
            ]
        }
        menuItems.push(reimbursements);
    }
    if (section === "billing" || (signupStatus?.billing?.required && onboarding)) {
        const urlBilling = `/employer-flow/billing?onboarding=${onboarding}&step=0`;
        const billing = {
            label: "Billing",
            section: "billing",
            disabled: !signupStatus?.billing?.editable || false,
            url: urlBilling,
        }
        if (section === "billing") {
            billing.steps = [
                {
                    label: "Billing",
                    name: "Billing",
                    disabled: false,
                    url: urlBilling,
                },
            ]
        }
        menuItems.push(billing);
    }
    if (section === "documents" || (signupStatus?.documents?.required && onboarding)) {
        const urlDocuments = `/employer-flow/documents?onboarding=${onboarding}&step=0`;
        const documents = {
            label: "Documents",
            section: "documents",
            disabled: !signupStatus?.documents?.editable || false,
            url: urlDocuments,
        }
        if (section === "documents") {
            documents.steps = [
                {
                    label: "Approve Documents",
                    name: "Approve Documents",
                    disabled: false,
                    url: urlDocuments,
                },
            ]
        }
        menuItems.push(documents);
    }
    return menuItems;
}
export function getUrl(employer, employerPlan, permissibleClass, section, step, onboarding) {
    // console.log(`getUrl called with section = ${section}, step = ${step}, onboarding = ${onboarding}, employer = ${employer?.id}, employerPlan = ${employerPlan?.id}, permissibleClass = ${permissibleClass?.id}`);
    let url = null;

    const roadmap = getNavigationMenu(section, step, onboarding, employer, employerPlan, permissibleClass);
    // console.log("roadmap in getUrl:", roadmap);
    const numRoadmapSections = roadmap.length;
    const currentRoadmapSectionIndex = roadmap.findIndex(item => item.section === section);
    const currentRoadmapSection = roadmap[currentRoadmapSectionIndex];
    const numSteps = currentRoadmapSection?.steps?.length || 0;
    let currentStep = null;
    if (step >= 0 && step < numSteps) {
        currentStep = currentRoadmapSection.steps[step];
    }
    // console.log("Current step in getUrl:", currentStep);
    let priorStep = null;
    if (step > 0) {
        priorStep = currentRoadmapSection.steps[step - 1];
    }
    // console.log("priorStep in getUrl:", priorStep);
    if (step < 0) {
        if (currentRoadmapSectionIndex === 0 && !onboarding) {
            url = "/employer-dashboard"
        } else {
            url = currentRoadmapSection.url;
        }
    } else if (priorStep?.subMenu && priorStep?.returnUrl && (!currentStep || !currentStep.subMenu)) {
        url = priorStep.returnUrl
    } else if (step >= numSteps) {
        if (currentRoadmapSectionIndex === numRoadmapSections - 1) {
            url = "/employer-dashboard"
        } else {
            url = roadmap[currentRoadmapSectionIndex + 1].url;
        }
    } else {
        if (numSteps > 0) {
            url = currentRoadmapSection.steps[step].url;
        } else {
            url = currentRoadmapSection.url;
        }
    }
    // console.log("getUrl returning:", url);
    return url;
}

export function getStepComponents(section, step, onboarding, employer, employerPlan = null, permissibleClass = null) {
    // console.log(`getStepComponents called with section = ${section}, step = ${step}, onboarding = ${onboarding}, employer = ${employer?.id}, employerPlan = ${employerPlan?.id}, permissibleClass = ${permissibleClass?.id}`);
    const roadmap = getNavigationMenu(section, step, onboarding, employer, employerPlan, permissibleClass);
    const currentRoadmapSectionIndex = roadmap.findIndex(item => item.section === section);
    const currentRoadmapSection = roadmap[currentRoadmapSectionIndex];
    const components = [];
    if (currentRoadmapSection?.steps?.length > 0) {
        for (let i = 0; i < currentRoadmapSection.steps.length; i++) {
            const stepItem = currentRoadmapSection.steps[i];
            if (stepItem.name === "Address") {
                components.push(Address);
            } else if (stepItem.name === "Organization") {
                components.push(Organization);
            } else if (stepItem.name === "Contact") {
                components.push(Contact);
            } else if (stepItem.name === "IndustryEligibility") {
                components.push(IndustryEligibility);
            } else if (stepItem.name === "Plans") {
                components.push(Plans);
            } else if (stepItem.name === "Plan Status") {
                components.push(Plan);
            } else if (stepItem.name === "Plan Year") {
                components.push(Dates);
            } else if (stepItem.name === "Classes") {
                components.push(Classes);
            } else if (stepItem.name === "Employee Groups") {
                components.push(Groups);
            } else if (stepItem.name === "Excluded Groups") {
                components.push(ExcludedGroups);
            } else if (stepItem.name === "Eligible Expenses") {
                components.push(EligibleExpenses);
            } else if (stepItem.name === "Eligible Individuals") {
                components.push(EligibleIndividuals);
            } else if (stepItem.name === "Allowance Type") {
                components.push(AllowanceType);
            } else if (stepItem.name === "Allowance") {
                components.push(Allowance);
            } else if (stepItem.name === "Allowance Metal") {
                components.push(AllowanceMetal);
            } else if (stepItem.name === "Allowance ACA") {
                components.push(AllowanceACA);
            } else if (stepItem.name === "Text-To-Confirm") {
                components.push(TextToConfirm);
            } else if (stepItem.name === "Reimbursement Method") {
                components.push(ReimbursementMethod);
            } else if (stepItem.name === "Reimbursement Timing") {
                components.push(ReimbursementTiming);
            } else if (stepItem.name === "Reimbursement Account") {
                components.push(ReimbursementAccount);
            } else if (stepItem.name === "Billing") {
                components.push(Billing);
            } else if (stepItem.name === "Approve Documents") {
                components.push(Documents);
            }
        }
    }
    return components;
}
